import React, { useState, useEffect } from 'react';
import MainLayout from '../components/MainLayout';
import axios from 'axios';
import { FileCheck, Download } from 'lucide-react';

const API_URL = process.env.REACT_APP_BACKEND_URL + '/api';

const ESSDocuments = () => {
  const [documents, setDocuments] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => { fetchAll(); }, []);

  const fetchAll = async () => {
    try {
      setLoading(true);
      const docs = await axios.get(`${API_URL}/ess/documents`, { withCredentials: true });
      setDocuments(docs.data || []);
    } catch (e) {
      console.error(e);
    } finally {
      setLoading(false);
    }
  };

  return (
    <MainLayout>
      <div data-testid="ess-documents-page" className="space-y-6 max-w-5xl">
        <h1 className="text-2xl font-bold text-slate-900">Documents</h1>

        <div className="flex space-x-1 bg-slate-100 rounded-lg p-1 w-fit">
          <button
            data-testid="tab-documents"
            className="flex items-center space-x-2 py-2 px-4 rounded-md text-sm font-medium bg-white text-slate-900 shadow-sm"
          >
            <FileCheck className="w-4 h-4" /><span>Documents</span>
          </button>
        </div>

        {/* DOCUMENTS TAB CONTENT */}
        <div className="bg-white rounded-xl border border-slate-200 divide-y divide-slate-100 overflow-hidden shadow-sm">
          {loading ? (
            <div className="p-10 text-center space-y-2">
              <div className="w-8 h-8 border-4 border-indigo-200 border-t-indigo-600 rounded-full animate-spin mx-auto mb-2" />
              <p className="text-sm text-slate-500">Loading documents…</p>
            </div>
          ) : documents.length > 0 ? documents.map((d, i) => (
            <div key={i} data-testid={`doc-${i}`} className="flex items-center justify-between p-4 hover:bg-slate-50/80 transition-colors">
              <div className="flex items-center space-x-3">
                <div className="p-2.5 bg-indigo-50 text-indigo-600 rounded-xl border border-indigo-100">
                  <FileCheck className="w-5 h-5" />
                </div>
                <div>
                  <p className="text-sm font-semibold text-slate-900">{d.document_type || d.name || d.title || 'Document'}</p>
                  <p className="text-xs text-slate-500 mt-0.5">{d.uploaded_at || d.issue_date || d.created_at || ''}</p>
                </div>
              </div>
              {(d.file_path || d.url || d.download_url || d.id) && (
                <a
                  href={d.download_url || d.url || (d.id ? `${API_URL}/ess/documents/${d.id}/download` : '#')}
                  target="_blank"
                  rel="noreferrer"
                  data-testid={`doc-download-${i}`}
                  className="flex items-center gap-1.5 px-3 py-1.5 bg-[#0052FF] hover:bg-[#0040CC] text-white rounded-lg text-xs font-semibold shadow-sm transition-colors"
                >
                  <Download className="w-3.5 h-3.5" /> <span>View / Download</span>
                </a>
              )}
            </div>
          )) : (
            <div className="p-10 text-center space-y-2">
              <FileCheck className="w-10 h-10 text-slate-300 mx-auto mb-3" />
              <p className="text-sm font-semibold text-slate-700">No documents available</p>
              <p className="text-xs text-slate-400 max-w-md mx-auto">
                Any official documents, policies, or letters issued to you will appear here.
              </p>
            </div>
          )}
        </div>
      </div>
    </MainLayout>
  );
};

export default ESSDocuments;

